<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/multishare/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      addShowPower="/multishare/add"
      @openAddDialog="handleAddShare(false)"
    >
      <el-form-item label="内容">
        <el-input
          v-model="formModel.titleName"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型描述">
        <el-select clearable v-model="formModel.type">
          <el-option
            v-for="item in type"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        type="index"
        min-width="80"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="titleName"
        show-overflow-tooltip
        min-width="160"
        label="内容"
      ></el-table-column>
      <el-table-column
        prop="type"
        show-overflow-tooltip
        min-width="160"
        label="类型描述"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 0 ? "禁用" : "启用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        show-overflow-tooltip
        min-width="160"
        label="创建时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="200"
        v-if="hasPerm('/multishare/caozuo')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleAddShare(true, scope.row)"
            class="button-color"
            >查看</el-button
          >
          <el-button
            type="text"
            @click="handleAddShare(false, scope.row)"
            class="button-color"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="handleStatus(scope.row.id, scope.row.status)"
            class="button-color"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            type="text"
            @click="handleDel(scope.row.id)"
            class="button-color"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import APPService from "service/APPService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "multishare",
  data() {
    return {
      tableData: [],
      page: {},
      isPage: false,
      submitService: APPService.tatTatSourceMaterialList,
      formModel: {
        titleName: "",
        type: "",
      },
      type: [],
    };
  },
  components: {
    CommonTopForm,
    CommonTable,
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        titleName: this.formModel.titleName.trim(),
        type: this.formModel.type.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["userId", "reloadPage"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getShareList();
    this.getType();
  },
  activated() {
    if (this.reloadPage) {
      this.getShareList();
    }
  },
  methods: {
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    getShareList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isReloadPage(false);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getType() {
      this.doLoad(
        APPService.tatTatSourceMaterialType,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.type = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    handleAddShare(isHaved, item) {
      this.$router.push({
        name: "multishareupdate",
        params: {
          isHaved: isHaved,
          item: JSON.stringify(item),
        },
      });
    },
    handleDel(id) {
      this.showConfirm("确定删除该素材？")
        .then(() => {
          this.doDelete(id);
        })
        .catch(() => {});
    },
    handleStatus(id, status) {
      this.showConfirm(`确定${status == 1 ? "禁用" : "启用"}该素材？`)
        .then(() => {
          this.doStatus(id, status);
        })
        .catch(() => {});
    },
    doStatus(id, status) {
      this.doLoad(
        APPService.tatTatSourceMaterialUdp,
        {
          userId: this.userId,
          id: id,
          status: status == 1 ? 0 : 1,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents.optMsg);
            this.getShareList();
          });
        },
        "信息获取失败"
      );
    },
    doDelete(id) {
      this.doLoad(
        APPService.tatTatSourceMaterialDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents.optMsg);
            this.getShareList();
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getShareList();
    },
    ...mapActions({
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/MultiShareNewWay.vue